<script>
    import {sgettext} from '../../../i18n.js';
    export let row;
</script>

{#if row?.delay_flags?.length}
    {row.delay_size} {sgettext('$$MIN$$')}
{/if}